import loadable from "@loadable/component";
import classnames from "classnames";
import Error404 from "components/Error404";
import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { useGlobal } from "reactn";
import RouteStatus from "./RouteStatus";
import Footer from "@ugitgud/legos/ui/footer/Footer";
import BuildPageContainer from "./Pages/Builds/BuildPageContainer";
import TierlistPageContainer from "./Pages/Tierlist/TierlistPageContainer";
import champsPageContainer from "./Pages/Heroes/heroesPageContainer";

// Loadable Components
const LandingPageContainer = loadable(() => import("components/Pages/LandingPage/LandingPageContainer"));
const disclaimerText =
  "U.GG Stats isn't endorsed by Valve and doesn't reflect the views or opinions of Valve or anyone officially involved in producing or managing Deadlock.";

const toPath = (name) => {
  return name.toLowerCase().split(" ").join("_");
};

const MainContent = (props) => {
  const { sideNavOpen } = props;
  const [verificationBar] = useGlobal("verificationBar");
  const location = useLocation();

  const mainContentClassNames = classnames({
    "verification-bar-active": verificationBar,
    collapsed: !sideNavOpen,
    expanded: sideNavOpen,
  });

  return (
    <div id="main-content" className={mainContentClassNames} ref={props.forwardedRef}>
      <div id="content-wrapper">
        <div id="content">
          <Switch>
            <Route exact path="/" component={LandingPageContainer} />
            <Route exact path="/deadlock" component={LandingPageContainer} />
            <Route path="/deadlock/heroes/:hero/build" component={BuildPageContainer} />
            <Route exact path="/deadlock/tier-list" component={TierlistPageContainer} />
            <Route exact path="/deadlock/heroes" component={champsPageContainer} />
            <RouteStatus statusCode={404} path="*">
              <Error404 />
            </RouteStatus>
          </Switch>
        </div>
        <Footer disclaimerText={disclaimerText} path={location.pathname} paddingLeft={70} />
      </div>
    </div>
  );
};

export default MainContent;
